import { request } from '@/utils/request';

// 获取仪表盘信息
export function statistics(params) {
  return request.get({
    url: '/api/v1/n/guarantee/statistics',
    params,
  });
}

// 获取公司信息
export function companyInfo(params) {
  return request.get({
    url: '/api/v1/n/company/details',
    params,
  });
}

// 查询客服信息
export function customerService(params) {
  return request.get({
    url: '/api/v1/platform',
    params,
  });
}

// 获取验证码
export function getVerificationCode(data) {
  return request.post({
    url: '/send/sms',
    data,
  });
}

// 换绑手机号
export function bindMobile(data) {
  return request.post({
    url: '/api/v1/n/user/updatePhone',
    data,
  });
}

// 修改个人信息
export function updateUserInfo(data) {
  return request.put({
    url: '/api/v1/n/user/updateInfo',
    data,
  });
}
